import React from 'react';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import { useListAdminUserRolesQuery } from '../../../API/administration/AdminUsersAPI';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { FlexRow, FormCell, Grid, Header2Text } from '../../../ui-toolkit';
import { RolesTable } from '../../../components/administration/roles/RolesTable';
import { CardTW } from '../../../tailwindComponents/CardTW/CardTW';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';

export const RolesContainer: React.FC = () => {
  const hasReadPermission = useHasPermissions([ePermissions.AuthIdentityRead]);

  const {
    data: adminUserRoles = [],
    isFetching,
    error,
  } = useListAdminUserRolesQuery(
    { include: 'users' },
    {
      skip: !hasReadPermission,
    }
  );

  return (
    <AccessControlCheck allowedPermissions={[ePermissions.AuthIdentityRead]}>
      <ErrorMessageTW rtkError={error} />
      <Grid data-test-id={'roles-page'}>
        <CardTW>
          <Grid>
            <FlexRow justifyContent={'space-between'} width={100}>
              <FormCell hintText={'All roles that can be assigned to a user'}>
                <Header2Text>Pinecone Roles</Header2Text>
              </FormCell>
            </FlexRow>
            <RolesTable data={adminUserRoles} isFetching={isFetching} />
          </Grid>
        </CardTW>
      </Grid>
    </AccessControlCheck>
  );
};
